import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { FullScreenLoader } from "@/components/FullScreenLoader";

/* Pure view. supabase-js handles the OAuth code exchange automatically
   (detectSessionInUrl: true in /lib/supabase.js). This component just reads
   the single auth state machine and routes.

     - initializing → spinner
     - authenticated → /homepage
     - anonymous → back to /login (OAuth failed or user cancelled) */

export default function AuthCallback() {
  const { status } = useAuth();

  if (status === "authenticated") {
    return <Navigate to="/homepage" replace />;
  }
  if (status === "anonymous") {
    return <Navigate to="/login" replace />;
  }
  return <FullScreenLoader label="Signing you in…" />;
}
